import { jsx as _jsx } from "react/jsx-runtime";
import { ToggleButton, ToggleButtonGroup } from 'react-aria-components';
import { cx } from './cx.js';
import { singleChoice } from './single-choice.js';
const sizes = {
    md: 'min-h-9 px-3.5 text-sm max-md:min-h-11',
    sm: 'min-h-8 px-3 text-xs [@media(pointer:coarse)]:min-h-11',
};
/**
 * A single choice out of a few, as one glass pill; the selected segment is inverse ink. Where the
 * pill is narrower than its labels (`max-w-full` in a slim column), the segments shrink and cut
 * their label short instead of running out of the column - the full label stays the button's
 * text for assistive technology.
 */
export function SegmentedControl({ options, value, onChange, size = 'md', appearance = 'glass', className, ...props }) {
    const field = appearance === 'field';
    return (_jsx(ToggleButtonGroup, { ...props, disallowEmptySelection: true, ...singleChoice(options, value, onChange), 
        // Labels stay whole: a narrow group scrolls sideways instead of cutting them to „N…“.
        className: cx('inline-flex max-w-full shrink-0 gap-0.5 overflow-x-auto rounded-full p-1 [scrollbar-width:none]', field ? 'bg-fill' : 'glass', className), children: options.map((o) => (_jsx(ToggleButton, { id: o.id, className: cx('flex-1 shrink-0 cursor-pointer whitespace-nowrap rounded-full font-semibold text-muted outline-none transition-colors', field
                ? 'hover:text-text data-selected:bg-accent data-selected:text-accent-on'
                : 'hover:bg-fill hover:text-text data-selected:bg-ink data-selected:text-ink-contrast', 'focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-focus', sizes[size]), children: o.label }, o.id))) }));
}
//# sourceMappingURL=segmented-control.js.map